export const FOCUS_PERIOD_KEY = 'focusPeriod';
export const EMAIL_VIEW_TIMER_KEY = 'emailViewTimerEnabled';
